// Hook qui fire 'page_view' à chaque changement de route dans une SPA
// React Router. GTM ne le fait PAS tout seul (il ne voit que le
// document.title initial). À mounter une fois au-dessus de <Routes>.

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { track } from './tracking';

export function useTrackPageView(): void {
  const location = useLocation();

  useEffect(() => {
    track('page_view', {
      page_path: location.pathname + location.search,
      page_title: document.title,
    });
  }, [location.pathname, location.search]);
}
